import axios from 'axios';

	// export const API_URL = 'http://127.0.0.1:8000/api';
 //  	export const API_UR = 'http://127.0.0.1:8000';


  // export const API_URL = 'https://api.maxicomm.com.mx/api';
  // export const API_UR = 'https://api.maxicomm.com.mx';

   
   export const API_URL = 'https://apicontpaq.maxicomm.com.mx/api';
  export const API_UR = 'https://apicontpaq.maxicomm.com.mx';



  /*importacion de bd del servidor a local*/

  /*    Forma #1
  cd /
  cd /xampp\mysql\bin     
  mysql -h localhost -u root -p cotizaciones<coti.sql;

  el archivo coti.sql tiene que estar en la carpeta bin

  */

  /*    Forma #2
  cd /
  cd /xampp\mysql\bin     
  mysql -h localhost -u root -p 
  **ingresas password
  use cotizaciones ;
  source coti.sql

  el archivo coti.sql tiene que estar en la carpeta bin

  */


 
export const request = axios.create({
	baseURL 		: API_UR,
	responseType 	: 'json'
});

export const api = () => {

	let token = localStorage.getItem('session_token_maxicom');

	token = JSON.parse(token);

	let AuthorizationToken = token.token_type+" "+token.access_token;

	return axios.create({
		baseURL 		: API_URL,
		responseType 	: 'json',
		headers 		: {'Authorization': AuthorizationToken }

	});

}
export const api_formdata = () => {

	let token = localStorage.getItem('session_token_maxicom');

	token = JSON.parse(token);

	let AuthorizationToken = token.token_type+" "+token.access_token;

	return axios.create({
		baseURL 		: API_URL,
		responseType 	: 'json',
		headers 		: {'Authorization': AuthorizationToken,'Content-Type': 'multipart/form-data', }

	});

}


// WEBPACK FOOTER //
// ./src/actions/_request.js